export default "__VITE_ASSET__DjQfV9V8__"